<template>
  <div>
    <!-- Barra de navegación en la parte superior -->
    <nav class="navbar-custom">
      <div class="navbar-left">
        <button @click="editarMaridaje" class="back-button">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h4 class="navbar-title">Maridar</h4>
      </div>
      <div class="navbar-right" v-if="imagenGenerada">
        <button @click="compartirURL" class="share-button">
          <i class="fas fa-share-alt"></i>
        </button>
      </div> 
    </nav>
 

    <!-- Contenedor principal con el resto del contenido -->
    <div class="container">
      <div class="container text-center">

        <!-- Mostrar la tabla de quesos generada -->
        <div v-if="imagenGenerada">
          <div class="tabla-quesos"> 
            <ul>
              <li v-for="queso in resultado.quesos" :key="queso.id">{{ queso.nombre }}</li>
            </ul>
          </div>

          <!-- Imagen de la tabla generada -->
          <img v-if="imagenUrl" :src="imagenUrl" alt="Tabla de Quesos Generada" class="tabla-imagen" />
          <!-- Leyenda de IA debajo de la imagen -->
          <p v-if="imagenGenerada" class="leyenda-ia">Generado en kroonmaridaje.com con IA</p>
        </div> 

        <!-- Mostrar placeholder mientras se carga la imagen final -->
        <div v-else class="oscilar" style="margin: 40px 0; text-align: center;">
          <img :src="require('../assets/placeholder-tabla.png')" alt="Placeholder Maridador" class="tabla-imagen" />
        </div>

        <!-- Mostrar la calificación y las coronas -->
        <transition name="fade">
          <div v-if="mostrarCalificacion" class="calificacion-container">
            <transition name="fade2s">
              <h3 class="mt-4">{{ rango }}</h3>
            </transition>
            <div class="coronas-container">
              <!-- Capa de fondo: 5 coronas en versión tenue -->
              <div class="coronas-fondo">
                <img 
                  v-for="index in 5" 
                  :key="'fondo' + index" 
                  :src="require('../assets/corona.png')"  
                  alt="Corona fondo" 
                  class="coronas-icon"/>
              </div>
              <!-- Capa revelada: coronas activas según la calificación -->
              <div class="coronas-activo">
                <img 
                  v-for="index in coronasReveladas" 
                  :key="'activo' + index" 
                  :src="require('../assets/corona.png')" 
                  alt="Corona activa" 
                  class="coronas-icon"/>
              </div> 
            </div> 
          </div> 
        </transition>

        <!-- Descripción de la tabla -->
        <div v-if="coronasReveladas" class="descripcion-tabla" style="margin-top: 10px;">
          <p style="text-align: left;"><strong>{{ descripcionTyped }}</strong></p>
        </div>

        <!-- Recomendaciones --> 
        <transition name="fade">
          <div v-if="mostrarRecomendacionesTabla" class="recomendaciones-container" style="margin-top:20px;">
            <h4 style="margin: 20px 0; color: white;">Recomendaciones</h4>
            <ol class="lista-recomendaciones">
              <li v-for="(sugerencia, index) in sugerencias" :key="index">{{ sugerencia }}</li>
            </ol> 
          </div>
        </transition>
        
        <!-- Lista de ingredientes -->
        <div v-if="imagenGenerada && resultado.ingredientes_spanish && resultado.ingredientes_spanish.length > 0" class="ingredientes-container">
          <h4 style="margin: 20px 0; color: white;">Lista de ingredientes</h4>
          <ol class="lista-ingredientes">
            <li v-for="(ingrediente, index) in ingredientesEspanol" :key="index">{{ ingrediente }}</li>
          </ol>
        </div>


        <!-- Botón de compartir -->
        <button v-if="imagenGenerada && uuidImagen" @click="compartirTabla" class="btn btn-warning mt-3">
              Pide likes <i class="fa-regular fa-share-from-square"></i>
        </button>

      </div> 
    </div>
  </div>
</template>

<script>
import { SparklesIcon } from '@heroicons/vue/outline';
import HeaderMaridador from '@/components/HeaderMaridador.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    HeaderMaridador,
    SparklesIcon
  },
  computed: {
    ...mapGetters(['resultado'])
  },
  data() {
    return {
      ingredientesEspanol: this.$route.query.ingredientes_spanish || null,
      ingredientesIngles: null,
      coronas: 0,
      coronasReveladas: 0,
      calificacion: 0,
      rango: '',
      descripcion: '',
      descripcionTyped: '',
      resumen: '',
      sugerencias: [],
      mostrarRecomendacionesTabla: false,
      mostrarImagenGenerada: false,
      cargandoImagen: false,
      imagenUrl: null,
      mensajeActual: 'Iniciando...',
      imagenGenerada: false,
      yaMostrada: false,
      mostrarCalificacion: false,
      m: false,
      mostrarBotonCompartir: false,
      uuidImagen: null,
      mostrandoGeneracionTabla: true,
      descripcionCargada: false,
      todoCargado: false
    };
  },
  watch: {
    resultado: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          console.log('Resultado antes de generar la imagen:', newVal);
          this.generarImagenTabla();
        }
      }
    }
  },
  mounted() {
    const ingredientesIngles = this.ingredientes_ingles;
    const ingredientesSpanish = this.ingredientes_spanish;
    const resultado = this.$store.getters.resultado;
    console.log('Resultado del maridaje:', resultado);

    if (resultado) {
      this.coronas = resultado.coronas;
      this.rango = resultado.rango;
      this.calificacion = resultado.calificacion;
      this.resumen = resultado.resumen;
      this.descripcion = resultado.descripcion;
      this.revelarCoronas();
      this.sugerencias = resultado.sugerencias;
      this.ingredientesEspanol = resultado.ingredientes_spanish;
      this.ingredientesIngles = resultado.ingredientes_english;
      this.queso = resultado.quesos[0];
      console.log('Ingredientes en ingles:', this.ingredientesIngles);
      console.log('Ingredientes en español:', this.ingredientesEspanol);
      this.todoCargado = true;
    }
  },
  methods: {
    editarMaridaje() {
      this.$router.push({ name: 'formulario' });
    },
    generarImagenIA() {
      if (this.cargandoImagen || this.imagenGenerada) {
        console.log('Ya se está generando una imagen o la imagen ya fue generada.');
        return;
      }

      console.log('Generando imagen con IA...');

      this.cargandoImagen = true;
      this.imagenGenerada = false;
      this.mensajeActual = "Produciendo tu tabla...";

      if (!this.ingredientesIngles) {
        console.error("Error: No se encontraron los ingredientes en inglés en la respuesta.");
        return;
      }

      const mensajes = [
        "Colocando el queso...",
        "Preparando ingredientes...",
        "Creando composición...",
        "Agregando detalles...",
        "Ajustando la luz...",
        "Últimos ajustes..."
      ];
      let index = 0;
      const intervalId = setInterval(() => {
        this.mensajeActual = mensajes[index];
        index++;
        if (index === mensajes.length) {
          clearInterval(intervalId);
        }
      }, 4000);

      const datosParaEnviar = {
        queso: this.queso,
        ingredientes: this.ingredientesIngles,
        descripcion: this.descripcion,
        coronas: this.coronas,
        rango: this.rango,
        sugerencias: this.sugerencias
      };

      console.log('Llamando a la API para generar imagen con ingredientes:', this.ingredientesIngles);
      console.log('Datos que se enviarán a la API:', datosParaEnviar);

      // this.llamarApiGeneraImagen(datosParaEnviar)
      //   .then((response) => {
      //     console.log('Imagen URL relativa:', response.imagen_url);
      //     this.imagenUrl = `${process.env.VUE_APP_IMAGE_URL}${response.imagen_url}`;
      //     console.log('Imagen URL construida:', this.imagenUrl);

      //     this.uuidImagen = response.uuid_imagen;
      //     this.mostrarImagenGenerada = true;
      //     this.imagenGenerada = true;
      //     this.yaMostrada = true;
      //     this.mostrarBotonCompartir = true;
      //     console.log('Imagen generada:', this.imagenUrl);
      //     console.log('La imagen ha sido generada exitosamente.');
      //   })
      //   .catch((error) => {
      //     if (error.status === 429) {
      //       this.mensajeActual = "Servidor de IA ocupado, reintenta más tarde";
      //       console.error("Servidor de IA ocupado, reintenta más tarde.");
      //     } else {
      //       console.error("Error al llamar a la API:", error);
      //     }
      //   })
      //   .finally(() => {
      //     this.cargandoImagen = false;
      //   });
    },
    regenerarImagenIA() {
      this.yaMostrada = false;
      this.cargandoImagen = true;
      this.imagenGenerada = false;
      this.mensajeActual = "Colocando el queso...";
      this.generarImagenIA();
    },
    llamarApiGeneraImagen(datos) {
      console.log('Datos enviados a la API:', datos);
      return fetch(`${process.env.VUE_APP_BACKEND_URL}/genera-imagen-sd`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      }).then(response => response.json());
    },
    cerrarModalImagen() {
      this.mostrarImagenGenerada = false;
    },
    compartirTabla() {
      if (!this.uuidImagen) {
        console.error("UUID no disponible. No se puede compartir.");
        return;
      }
      const url = `${window.location.origin}/tabla/${this.uuidImagen}`;
      console.log('URL para compartir:', url);
      
      if (navigator.share) {
        navigator.share({
          title: 'Mi tabla de quesos Kroon está concursando:',
          text: 'Dale like y crea la tuya.',
          url: url
        })
        .then(() => {
          console.log('Ya compartiste tu tabla.');
        })
        .catch(error => {
          console.error('Error al compartir:', error);
        });
      } else {
        alert('Tu navegador no soporta la funcionalidad de compartir.');
      }
    },
    generarImagenTabla() {
      console.log('Generando imagen con IA...');
      console.log('Datos para enviar a la API:', this.resultado);
      if (!this.resultado) {
        console.error('Resultado no disponible para generar la imagen');
        return;
      }

      const datos = {
        quesos: this.resultado.quesos,
        ingredientes: this.resultado.ingredientes_english || [],
          ingredientes_adicionales: this.resultado.ingredientes_adicionales_ingles || []
      };

      console.log('Datos para generar imagen:', datos);

      fetch(`${process.env.VUE_APP_BACKEND_URL}/genera-imagen-sd`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      })
        .then(response => response.json())
        .then(data => {
          this.imagenUrl = `${process.env.VUE_APP_IMAGE_URL}${data.imagen_url}`;
          this.imagenGenerada = true;
          this.uuidImagen = data.uuid_imagen;
          console.log('Imagen generada:', this.imagenUrl);
          console.log('UUID de la imagen:', data.uuid_imagen);
          this.imagen_uuid = data.uuid_imagen;
          this.todoCargado = true;
          console.log('Todo cargado:', this.todoCargado);
          // Desplegar botón de compartir
          this.mostrarBotonCompartir = true;
          console.log('Boton de compartir desplegado:', this.mostrarBotonCompartir);
          // Mostrar la imagen generada
          this.mostrarImagenGenerada = true;
          console.log('Imagen generada mostrada:', this.mostrarImagenGenerada);
        })
        .catch(error => {
          console.error('Error al generar la imagen:', error);
        });
    },
    escribirDescripcion() {
      this.descripcionTyped = '';
      const text = this.descripcion;
      if (!text) return;
      const palabras = text.split(' ');
      let i = 0;
      const intervalId = setInterval(() => {
        this.descripcionTyped += (i === 0 ? '' : ' ') + palabras[i];
        i++;
        if (i >= palabras.length) {
          clearInterval(intervalId);
          this.descripcionCargada = true;
          this.mostrarCalificacion = true;
          // esperar 2 segundos y mostrar las recomendaciones
          setTimeout(() => {
            this.mostrarRecomendacionesTabla = true;
          }, 2000);
        }
      }, 300);
    },
    revelarCoronas() {
      this.coronasReveladas = 0;
      const intervalo = setInterval(() => {
        if (this.coronasReveladas < this.coronas) {
          // mostrandolas una por una
          this.coronasReveladas++;
        } else {
          // esperar 2 segundos y mostrar la descripcion
          clearInterval(intervalo);
          setTimeout(() => {
            this.escribirDescripcion();
          }, 2000);
        }
      }, 500);
      this.mostrarCalificacion = true;
    },
    compartirURL() {
      if (navigator.share) {
        navigator.share({
          title: 'Mi tabla de quesos',
          text: '¡Vota por mi tabla de quesos!',
          
          url: `${window.location.origin}/tabla/${this.imagen_uuid}`
        })
        .then(() => {
          console.log('Contenido compartido exitosamente');
        })
        .catch(error => {
          console.error('Error al compartir:', error);
        });
      } else {
        alert('Este navegador no soporta la funcionalidad para compartir.');
      }
    }
  }
};
</script>

<style scoped>
/* Estilos para la barra de navegación */
.navbar-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #181818;
  color: #fff;
  border-bottom: 1px solid #444;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.navbar-right {
}

.back-button {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  margin-right: 10px;
}

.navbar-title {
  font-size: 1.5rem;
  margin: 0;
}

/* Estilos existentes */
.sparkles-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.sparkles-icon-small{
  width: 14px;
  height: 14px;
  margin-right: 4px;
}


li.sugerencia {
  margin-bottom: 20px;
  line-height: 1.1;
  font-size: 1.2rem;
  color: white;
  text-align: left;
}

a.recrear-link {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-block;
  font-size: 14px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  z-index: 10;
}

a.recrear-link:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

h1 {
  color: #f1c40f;
}

.coronas {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.coronas-icon {
  font-size: 30px;
  margin: 0 5px;
}

.recomendaciones-link {
  font-size: 1.1em;
  color: #a8946b;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 20px;
}

.recomendaciones-link:hover {
  color: #f1c40f;
}

.spinner-border {
  margin-right: 5px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(60, 60, 60, 0.7);
  display: flex;
  border: 1px solid #444;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  padding: 10px !important;
}

.modal-content {
  background-color: #181818;
  color: #fff;
  padding: 10px !important;
  border-radius: 10px;
  border: 1px solid #000;
  width: 100%;
  position: relative;
}

.modal-body {
  overflow-y: auto;
  text-align: left;
  padding: 10px 10px;
}

.leyenda-ia {
  font-size: 0.8rem;
  margin-top: 0px;
  color: #ccc;
  text-align: center;
}

.delicia-titulo {
  font-size: 2rem;
  color: #f1c40f;
  margin-top: 10px;
  text-align: center;
}

.delicia-subtitulo {
  font-size: 1rem;
  color: #f1f1f1;
  text-align: center;
  margin-bottom: 0px;
}

ol {
  text-align: left;
  padding-left: 20px;
}

ol li {
  margin-bottom: 0px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  background: none;
  border: none;
}

.close-button:hover {
  color: #ccc;
}

.tabla-quesos {
  margin: 20px 0;
  text-align: left;
}

.tabla-quesos ul {
  list-style-type: none;
  padding: 0;
}

.tabla-quesos li {
  margin: 5px 0;
}

.tabla-imagen {
  max-width: 100%;
  border-radius: 0px;
}

.imagen-placeholder {
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #ccc;
  margin: 20px 0;
}

.placeholder-text {
  font-size: 1.2em;
  color: #888;
}

.imagen-contenedor {
  position: relative;
  margin: 0 auto;
  min-width: 300px;
  min-height: 300px;
}

.placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  color: #333;
  font-size: 1.2em;
}

.fade-enter-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.descripcion-palabra {
  margin-right: 4px;
}

.share-button {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  margin-right: 10px;
}

.calificacion-container {
  text-align: center;
  margin-top: 20px;
}

.coronas-container {
  position: relative;
  display: inline-block;
}

/* Mantiene la misma dimensión para los íconos de corona */
.coronas-icon {
  max-height: 30px;
  margin: 0 5px;
}

/* Estilo para la capa de fondo: coronas en versión tenue */
.coronas-fondo img {
  opacity: 0.3;
}

/* La capa activa se posiciona de forma absoluta para sobreponerse a la de fondo */
.coronas-activo {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}

.fade2s-enter-active {
  transition: opacity 2s;
  transition-delay: 3s;
}
.fade2s-enter-from {
  opacity: 0;
}
.fade2s-enter-to {
  opacity: 1;
}

.recomendaciones-container {
  margin-top: 20px;
  text-align: center;
}


.ingredientes-container {
  text-align: center;
  margin-top: 20px;
  max-width: 80%;
  margin: 10px auto;
}

/* Definición de la animación que oscila la opacidad */
@keyframes oscilar {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.3;
  }
}

/* Aplica la animación de forma infinita */
.oscilar {
  animation: oscilar 2s ease-in-out infinite;
}

.lista-ingredientes {
    margin: 0;
    padding-left: 0;
    list-style-position: outside;
  }

.lista-recomendaciones {
  margin: 6px;
  line-height: 1.1;
  padding-left: 35px;
  list-style-position: outside;
}

.lista-recomendaciones li {
  margin-bottom: 10px;
}
</style>
